import { Button } from 'primereact/button';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { MonitoringFilters } from './MonitoringFilters';
import { setReportsFilter } from '../../redux/reducers/filterReportsSlice';
import { reportsFilterInitialState } from '../../models/ReportsFilter';
import { useAppDispatch } from '../../redux/hooks';
import { Suspense, useState } from 'react';

export const MonitoringFilter = () => {
  const dispatch = useAppDispatch();
  const [resetKey, setResetKey] = useState<number>(0);

  const clearFilters = () => {
    setResetKey(prev => prev + 1);
    dispatch(setReportsFilter(reportsFilterInitialState));
  };

  const headerAccordion = (
    <div className="flex justify-content-between align-items-center">
      <h3>Report Settings & Filters</h3>
      <Button
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          clearFilters();
        }}
        label="Reset All"
        link
        rounded
      />
    </div>
  );

  return (
    <Accordion activeIndex={0} className="col-12 nc_no-active">
      <AccordionTab header={headerAccordion}>
        <Suspense>
          <MonitoringFilters key={resetKey} />
        </Suspense>
      </AccordionTab>
    </Accordion>
  );
};
